export default "<router-outlet></router-outlet>\n\n<div *ngIf=\"loading\">\n  Loading....\n</div>\n"